<template>

  <div>

    <el-form :inline="true" label-width="120px">

      <el-row :gutter="8">
        <el-col :span="12">

          <el-form-item v-if="isTowerCo()">
            Technical Proposal type: <strong>{{step2p2.state.tpType}}</strong>
          </el-form-item>

          <select-tech-proposal v-else  v-model="step.state.tpType" :disabled=" disabled && !isApproved" />

        </el-col>


        <el-col v-if="isTelco()" :span="12">
          <text-input label="Site Id" v-model="step.state.siteId" :disabled="disabled && !isApproved" />
        </el-col>

        <el-col v-else :span="12">
          <el-form-item label="Telco Site ID">
            <b v-if="isTelco()">{{step.state.siteId}}</b>
            <b v-else>{{step2p2.state.siteId}}</b>
          </el-form-item>
        </el-col>

      </el-row>

      <el-row v-if="!isBackhaul" :gutter="8">
        <el-col :span="12">
          <select-service-type  v-model="step2p2.state.serviceType" :disabled="disabled && !isApproved" />
        </el-col>

        <el-col :span="12">
          <select-spectrum v-model="step2p2.state.spectrumBand" :disabled="disabled && !isApproved" />
        </el-col>
      </el-row>

</el-form>



<section v-if="isTelco()">

  <div v-if="step2p1 && step2p1.approvedStatus && !isPending">
    <el-row>
      <el-col :span="24" v-if="step2p1.approvedStatus !== 'Pending'">
        <h2>{{step2p1.approvedStatus}}</h2>
        <p><i>{{step2p1.approvedStatus}} on {{formatDate(step2p1.approved_at)}}</i></p>
        <p v-if="step2p1.state.reSurvey || step2p1.state.reviseTP"><strong>Actions Required</strong></p>
        <p v-if="step2p1.state.reSurvey"><i class="fa fa-check"></i> Re-survey Required</p>
        <p v-if="step2p1.state.reviseTP"><i class="fa fa-check"></i> Revise Technical Propsal</p>

        <div v-if="step2p1.remarks">
          <div class="html-remarks">
            <strong v-text="step2p1.approvedStatus + ' Remarks'"></strong>
            <p v-if="step2p1.remarks" v-safe-html="step2p1.remarks"></p>
            <p v-else class="text-muted">No remarks</p>
          </div>
        </div>

      </el-col>
    </el-row>

  </div>

</section>

<section v-else>
  <el-row>
    <el-col :span="16">
      <p v-if="step.remarks" v-safe-html="step.remarks"></p>
      <p v-else class="text-muted">No remarks</p>
    </el-col>
  </el-row>

  <el-form :inline="true">
    <el-collapse v-model="showPane" accordion>

    <!-- Approval - - - - - - - - - - - - - - - - - - - - - - - - - -->
    <el-collapse-item v-if="isTowerCo()" name="Approval">
      <template #title>
          <b>{{step.approvedStatus ? step.approvedStatus : 'Pending' }}</b>
          &nbsp;
          <span v-if="!step.approved">Approval</span>
          &nbsp;
          <i v-if="step.approved" class="header-icon fa fa-check-circle text-success"></i>
          <i v-if="step.approvedStatus === 'Conditional'" class="header-icon fa fa-question-circle text-warning"></i>
          <i v-if="step.approvedStatus === 'Rejected'" class="header-icon fa fa-exclamation-circle text-danger"></i>
          <i v-if="!step.approved && (step.approvedStatus !== 'Rejected' && step.approvedStatus !== 'Conditional')" class="header-icon fa fa-info-circle text-muted"></i>
          &nbsp;
          <i v-if="step.approved && step.approvedStatus === 'Approved'">{{formatFriendlyDate(step.approved_at)}}</i>
      </template>

        <el-form-item label="Approval">
          <select-approval-status
          v-model="step.approvedStatus"
          :disabled="!(!disabled && isApprover() && canAccess('project'))"
          @change="approval()"
        />

      </el-form-item>

      <date-input label="Date" v-if="!isPending" v-model="step.approved_at" :format="dateFormat" :disabled="!(!disabled && isApprover() && canAccess('project'))" />

      <check-box label="" v-if="!isPending" v-model="step.state.reviseTP"
        :disabled="!(!disabled && isApprover() && canAccess('project'))">Revise {{step.state.tpType}}</check-box>

      <check-box label="" v-if="!isPending" v-model="step.state.reSurvey"
        :disabled="!(!disabled && isApprover() && canAccess('project'))">Re-survey</check-box>

    </el-row>


    <el-row v-if="!step.approved || !isViewOnly() || (isApprover() && canAccess('project'))">

      <el-alert
        v-if="isActive(this.actionData)"
        type="warning"
        title="Please Note"
        description="These remarks will be visible to the sharer as well and will be sent in the approval e-mail."
        show-icon />
      <el-alert
        v-else
        type="primary"
        title="Approval Remarks"
        show-icon />

      <html-input v-model="step.remarks" cls-style="height: 34vh; width: 58.8vw; overflow: auto;" :disabled="disabled" />
    </el-row>


    <el-row v-if="isApprover() && canAccess('project')" align="right">
      <el-form-item>
        <el-button
          :type="approvalButton"
          @click="sendApproval()"
          :disabled="!canWriteStep() || !step.approvedStatus">
          Send {{step.approvedStatus}} e-Mail
        </el-button>
      </el-form-item>

      <el-form-item v-if="isRejected">
        <check-box style="background-color: #faedd9" border @change="setRejected">Close this Request permanently?</check-box>
      </el-form-item>

    </el-row>
</el-collapse-item>


  <!-- RTS ONLY: Equipment Input - - - - - - - - - - - - - - - - - - - - - - - - - -->
  <el-collapse-item name="Telco Equipment" v-if="!isViewOnly() && (!step.approved && step.actionType==='RTS' && isActive(this.actionData))">
    <template #title>
        Allow Telco to Add Equipment&nbsp;
        <i v-if="step.state.allowClientEquipmentInput" class="header-icon fa fa-check-circle text-primary"></i>
        <i v-else class="header-icon fa fa-minus-circle text-warning"></i>
    </template>
    <el-form-item>
      <check-box v-model="step.state.allowClientEquipmentInput" :disabled="disabled">Allow Telcos to Input Equipment?</check-box>
    </el-form-item>
  </el-collapse-item>

</el-collapse>
</el-form>

</section>


<!-- RTS ONLY: Equipment Form -->
<section v-if="(!isViewOnly() && isTowerCo() && (actionData.status != 'Closed' && actionData.status != 'Rejected')) || (isTelco() && step.state.allowClientEquipmentInput)">

  <el-form v-if="!isViewOnly() && step.actionType==='RTS' && !step.approved" label-position="top" v-model="item">

    <el-row :gutter="8" v-if="(isTelco() && step.state.allowClientEquipmentInput) || (isTowerCo())">
      <el-col :xs="24" :sm="24" :md="12" :lg="7" style="padding-top: 0.28em;"> <!-- :show-levels="false" -->
        <select-equip-category label="Type" v-model="catType"  size="small" :disabled="disabled" @change="nameCat" />
      </el-col>

      <el-col :xs="23" :sm="23" :md="11" :lg="4">
        <number-input prop="qty" label="Qty" v-model="item.qty" size="small" :min="1" :disabled="disabled" />
      </el-col>

      <el-col :xs="23" :sm="23" :md="11" :lg="4">
        <number-input prop="setNo" label="Set #" v-model="item.setNo" size="small" :min="1" :disabled="disabled" />
      </el-col>

      <el-col :xs="23" :sm="23" :md="11" :lg="4">
        <float-input prop="size" label="Dia." v-model="item.size" size="small" suffix="⌀ mm" :min="1" :disabled="disabled" />
      </el-col>

      <el-col :xs="23" :sm="23" :md="11" :lg="4">
        <float-input prop="agl" label="Height" v-model="item.agl" size="small" suffix="AGL" :min="0" :disabled="disabled" />
      </el-col>

      <el-col :xs="24" :sm="12" :md="6" :lg="isTelco() ? 3 : 4">
        <el-form-item v-if="isTowerCo()" prop="billable" :label="'Billable ' + money">
          <el-switch active-text="Yes" inactive-text="No" v-model="item.billable" size="small" :disabled="disabled" />
        </el-input>
      </el-form-item>
    </el-col>

    <el-col v-if="item.billable" :xs="23" :sm="11" :md="5" :lg="5" :offset="1">
      <float-input prop="amount" label="Amount" v-model="item.amount" size="small" :prefix="money" :min="0" :disabled="disabled" />
    </el-col>

    <el-col v-if="item.billable"  :xs="23" :sm="11" :md="6" :lg="5" :offset="1">
      <select-frequency size="small" v-model="item.frequency" :disabled="disabled" />
    </el-col>

    <el-col v-if="!disabled && !step.approved" align="right" :xs="24" :sm="12" :md="2" :lg="2">
      <el-form-item  style="padding-top: 2.5em;">
        <el-button
          type="success"
          :size="this.isDesktop ? 'large' : 'small'"
          icon="fa fa-plus"
          @click="addRow()"
          :disabled="!item.name && !item.quantity > 0">
          {{isDesktop? 'Add' : ''}}
        </el-button>
      </el-form-item>
    </el-col>
  </el-row>

</el-form>

</section>

<!-- RTS ONLY -->
<section v-if="equipment && equipment.length > 0">
  <br />
  <h4>Equipment</h4>
  <div style="display: block;">
    <el-table
    :data="equipment"
    show-summary
    sum-text="Totals"
     border style="width: 100%"
     stripe
     max-height="300">

<!--
    <el-table-column label="Type">
          <template #default="scope">
            <span v-if="equipment[scope.$index].typeName">
              {{equipment[scope.$index].type[equipment[scope.$index].type.length-1]}}
            </span>
          <i v-if="equipment[scope.$index].addedByClient" class="fa fa-user text-muted">&nbsp;</i>
          </template>
    </el-table-column>
-->
    <el-table-column prop="name" label="Type" :width="this.isDesktop ? 396 : 220" align="left" />
    <el-table-column prop="qty" label="Qty" align="right" />
    <el-table-column class="hidden-md-and-down" prop="setNo" label="Set #" align="right" />
    <el-table-column class="hidden-md-and-down" prop="size" label="Size" align="right" />
    <el-table-column class="hidden-md-and-down" prop="agl" label="AGL" align="right" />

    <el-table-column class="hidden-sm-and-down" prop="billable" label="Billable">
      <template #default="scope">
        <b>{{equipment[scope.$index].billable ? 'Y' : 'N'}}</b>
      </template>
    </el-table-column>

    <el-table-column v-if="isTowerCo()" class="hidden-sm-and-down" prop="amount" :label="money">
      <template #default="scope">
        <span v-if="equipment[scope.$index].amount">{{formatNumber(equipment[scope.$index].amount)}}</span>
        <i v-if="equipment[scope.$index].frequency" class="text-muted"><small>{{equipment[scope.$index].frequency}}</small>&nbsp;</i>
      </template>
    </el-table-column>

    <el-table-column label="="
      v-if="!disabled && !step.approved && (this.isTelco() ? step.state.allowClientEquipmentInput : true)"
      align="center">
      <template #default="scope">
        <el-button v-if="isTowerCo() && !step.approved || (isTelco() && equipment[scope.$index].addedByClient)"
        @click.native.prevent="deleteRow(scope.$index, equipment)"
        type="danger" icon="fa fa-trash-alt" size="mini" circle>
      </el-button>
    </template>
  </el-table-column>
</el-table>
</div>
</section>

<section v-if="actionData.actionType !== 'RTS'">
  <equip-table
    :title="(isBackhaul ? 'Backhaul' : actionData.organisation.shortName) + ' Equipment'"
    :site-id="actionData.site_id"
    :owner-id="actionData.organisation_id"
    :site-data="actionData.site"
    :filter-col="isBackhaul ? 'type' : null"
    :filter-val="isBackhaul ? 'backhaul' : null" />
</section>

<html-input v-if="actionData.actionType === 'RTD'" v-model="step.remarks" cls-style="height: 34vh; width: 58.8vw; overflow: auto;" :disabled="disabled" />

</div>
</template>



<script>

import {settings} from '@/components/Data'

import DateMixins from '@/mixins/DateMixins'
import RequestMixins from '@/mixins/RequestMixins'

import FileDownload from '@/components/atoms/files/FileDownload'
import FileUpload from '@/components/atoms/files/FileUpload'

import SelectApprovalStatus from '@/components/atoms/selects/SelectApprovalStatus'
import SelectEquipCategory from '@/components/atoms/selects/SelectEquipCategory'
import SelectFrequency from '@/components/atoms/selects/SelectFrequency'

import SelectSpectrum from '@/components/atoms/selects/SelectSpectrum'
import SelectServiceType from '@/components/atoms/selects/SelectServiceType'

import SelectTechProposal from '@/components/atoms/selects/SelectTechProposal'

import EquipTable from '@/components/assets/EquipTable'

export default {
  components: {
    EquipTable,
    FileDownload,
    FileUpload,
    SelectApprovalStatus,
    SelectEquipCategory,
    SelectFrequency,
    SelectSpectrum,
    SelectServiceType,
    SelectTechProposal
  },

  mixins: [DateMixins, RequestMixins],

  props: {

    rowData: {
      type: Object,
      required: true
    },

    rowIndex: {
      type: Number,
      required: true
    },

    stepData: {
      type: Object,
      default: null
    },

    readOnly: {
      type: Boolean,
      default: true
    }

  },



  methods: {

    approval () {
      this.ensureState(this.step)
      this.step.approvedStatus === 'Approved' ? this.step.approved = true : this.step.approved = false

      if (this.step.approved) {
        this.step.approved_by = this.userName()
      } else {
        this.step.approved_by = null
        this.step.approved_at = null
        this.step.state.reSurvey = false
        this.step.state.reviseTP = false
      }
    },



    setRejected (value) {

      this.$confirm('This <b>cannot</b> be undone. Continue?', 'Reject Request', {
        confirmButtonText: 'Reject',
        cancelButtonText: 'Cancel',
        center: true,
        dangerouslyUseHTMLString: true,
        type: 'error'
      }).then(() => {
        this.actionData.status = 'Rejected'
        this.saveStep(this.step, null, this.actionData, true)
        this.$refs.rtsTable.hideDetailRow(this.rowIndex)
      }).catch((e) => {
        console.error('error', e)
        this.$message({
          type: 'info',
          message: 'Rejection cancelled'
        })
      })
    },



    ensureState (s) {
      if (typeof s === 'object' && s !== null && (s.state === null || s.state === undefined)) {
        this.$set(s, 'state', {})
      }
      return s
    },



    setStep (data) {

      if (data) {
        this.ensureState(data)
        this.step = data
      }

    },



    nameCat (data) {

      this.item.category = data[0] ? data[0] : null
      this.item.type = data[1] ? data[1] : null
      this.item.subType = data[2] ? data[2] : null
      this.item.variant = data[3] ? data[3] : null

      this.item.name = this.item.category + (this.item.type ? ' / ' + this.item.type : '')
      this.item.name += (this.item.subType ? ' / ' + this.item.subType : '')
      this.item.name += (this.item.variant ? ' / ' + this.item.variant : '')
    },



    addRow () {
      if (!this.equipment) {
        this.equipment = []
      }

      this.equipment.push(this.clone(this.item))

      this.item.category = null
      this.item.type = null
      this.item.subType = null
      this.item.variant = null
      this.item.name = null
      this.item.qty = 1
      this.item.agl = 0
      this.item.size = 0
      this.setNo = 0
      this.item.billable = false
      this.item.amount = null
      this.item.frequency = null
      this.item.addedByClient = this.isTelco()

//      this.saveStep(this.step)
    },


    deleteRow (index, rows) {
      rows.splice(index, 1)
    },


    sendApproval () {
      this.ensureState(this.step)

      this.approvalAlert(this.requestsInfo,
        (this.step.approvedStatus ? this.step.approvedStatus : 'Pending Approval'),
        this.formatDate(this.step.approved_at),
        this.step.remarks,
        this.step.state.siteId,
        this.step.state.reSurvey ? 'Re-survey required' : '',
        this.step.state.reviseTP ? ('Revise ' +
        (this.step.state.tpType ? this.step.state.tpType : 'Technical Proposal') + ' required.') : '',
        this.isBackhaul && this.backhaul
        ? 'Backhaul Provider: ' + this.backhaul.providerName +
        (this.backhaul.backhaulType ? ' (Type: ' + this.backhaul.backhaulType + ')' : '')
         : '')
    },

  },



  data () {

    return {

      money: settings.currency,
      dateFormat: settings.selectDateFormat,

      item: {category: null, type: null, subType: null, variant: null, name: null, qty: 1, size: 0, agl: 0, billable: false, amount: null, frequency: null, addedByClient: this.isTelco()},

      actionData: this.rowData,

      backhaul: this.rowData && this.rowData.backhaul ? this.rowData.backhaul : null,

      step: this.stepData,

      catType: [],

      step2p1: null,
      step2p2: null,
      isApproved: false,

      showPane: this.isTelco() ? 'Equipment' : 'Approval',

      equipment: this.rowData.state.step2.equipment,

      requestsInfo: this.info(this.rowData, this.stepData, 2),

    }

  }, // data


  computed: {

    disabled () {
      return !this.canWriteStep() || this.isViewOnly() || this.readOnly ||
        (this.stepData ? this.stepData.approved && this.stepData.approvedStatus === 'Approved' : true) ||
        this.rowData.status === 'Closed' || this.rowData.status === 'Rejected'
    }

  },



  created () {

//    console.log('requestsInfo', this.requestsInfo)

    if (this.step) {
      this.ensureState(this.step)

      if (this.canWriteStep() && !this.readOnly) {
        this.findStep(this.stepData.id, this.setStep)
      }

    this.step2p1 = this.findWorkflowStep(2, 1, this.rowData.steps)
    this.ensureState(this.step2p1)
    this.step2p2 = this.findWorkflowStep(2, 2, this.rowData.steps)
    this.ensureState(this.step2p2)

    if (this.step && this.step.stepNo === 2 && this.step.partyNo === 1) {
        this.step2p1 = this.step
    }


    if (this.step && this.step.stepNo === 2 && this.step.partyNo === 2) {
        this.step = this.step2p2
    }


    if (this.step2p1) {
       this.isApproved = (this.step2p1.approvedStatus === 'Approved')
    }

      // Fix existing data: RTS mixins
      this.fixExistingEquipment()

    }

  },



  beforeDestroy () {

    if (!this.readOnly && this.step) {
      this.$emit('updated', this.step)

      if (this.canWriteStep()) {
        if (this.step.stepNo === 2 && this.step.partyNo === 1) {
          this.saveStep(this.step2p2, null, this.actionData)
        }

        if (this.step.stepNo === 2 && this.step.partyNo === 2) {
          this.saveStep(this.step2p2, null, this.actionData)
        }

        this.saveStep(this.step, null, this.actionData)
      }
    }

  }

}
</script>


<style scoped>
  .el-table__header {
    table-layout: auto !important;
  }
</style>
